import clsx from 'clsx';
import React, { forwardRef, useMemo } from 'react';
import { Icon } from '../../icon';
import { Loader } from '../../loader';
import { overrideProps } from '../../utils';
import { BaseButton } from '../base-button';
import styles from './styles.module.css';
/**
 * `<RegularButton />` —  обычная кнопка, позволяет совершить действие или сделать выбор.
 *
 * _Внимание! В будущим имя будет заменено просто на `<Button/>`_
 *
 * @example ```tsx
 * <RegularButton>Click Me</RegularButton>
 * ```
 */
export const RegularButton = overrideProps(/*#__PURE__*/forwardRef(function RegularButton({
  iconLeft,
  children,
  iconRight,
  wide,
  rounded,
  iconOnly,
  className,
  size = 'm',
  variant = 'primary',
  label,
  'aria-label': ariaLabel,
  left,
  right,
  loading,
  ...propsWithPossibleInvert
}, ref) {
  const {
    invert,
    ...props
  } = propsWithPossibleInvert;
  const composite = Boolean(left || right);
  const isShadowVariant = variant === 'shadow';
  const normalizedVariant = isShadowVariant ? 'primary' : variant;
  const classNames = useMemo(() => clsx(styles.regularButton, normalizedVariant && styles[normalizedVariant], className, size && styles[size], {
    [styles.wide]: wide,
    [styles.rounded]: rounded,
    [styles.square]: iconOnly,
    [styles.composite]: composite,
    [styles.loading]: loading,
    [styles.invert]: isShadowVariant ? true : invert,
    [styles.shadow]: isShadowVariant
  }), [isShadowVariant, normalizedVariant, className, size, wide, rounded, iconOnly, composite, loading, invert]);
  const iconSize = size ? iconSizesByButtonSize[size] : 0;
  if (loading) {
    props.disabled = true;
  }
  return /*#__PURE__*/React.createElement(BaseButton, {
    ref: ref,
    className: classNames,
    "aria-label": label != null ? label : ariaLabel,
    ...props
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.contentWrap
  }, composite ? (/*#__PURE__*/React.createElement(React.Fragment, null, !left && iconLeft ? /*#__PURE__*/React.createElement(Icon, {
    size: iconSize
  }, iconLeft) : /*#__PURE__*/React.createElement("div", null, left), !right && iconRight ? /*#__PURE__*/React.createElement(Icon, {
    size: iconSize
  }, iconRight) : /*#__PURE__*/React.createElement("div", null, right))) : (/*#__PURE__*/React.createElement(React.Fragment, null, iconLeft && (/*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    className: styles.iconLeft
  }, iconLeft)), iconOnly ? /*#__PURE__*/React.createElement(Icon, {
    size: iconSize
  }, children) : children, iconRight && (/*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    className: styles.iconRight
  }, iconRight))))), loading && (/*#__PURE__*/React.createElement("span", {
    className: styles.loader
  }, /*#__PURE__*/React.createElement(Loader, {
    size: size,
    variant: "inherit"
  }))));
}));
const iconSizesByButtonSize = {
  s: 20,
  m: 20,
  l: 24
};